// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError, AxiosResponse } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getCart } from '../../apis/ec';
import { CartItem } from '../../types/Cart';
import { getCartActions } from '../actionCreators/getCartActions';
import { RootAction } from '../rootActionCreator';
import { RootState } from '../rootReducer';

const outputActions = {
  success: getCartActions.success,
  failure: getCartActions.failure
};

type RequestActionTypes = ActionType<typeof getCartActions.request>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const getCartEpic = (
  action$: Observable<RootAction>,
  _state$?: Observable<RootState>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getCartActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // send api promise
      return getCart()
        .then((response: AxiosResponse<CartItem[]>) => {
          // handle success case here
          return getCartActions.success({
            cartItems: response.data
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return getCartActions.failure({ error });
        });
    })
  );
};
